import { logError } from '@/Module/Core/Helper';

export const exitFullscreen = (): Promise<void> => {
  return new Promise((resolve, reject) => {
    if (!document.fullscreenElement) {
      resolve();
      return;
    }

    const exitFullscreenFunction =
      document.exitFullscreen ||
      (document as any).webkitExitFullscreen ||
      (document as any).mozCancelFullScreen ||
      (document as any).msExitFullscreen;

    if (exitFullscreenFunction) {
      exitFullscreenFunction
        .call(document)
        .then(resolve)
        .catch((error: Error) => {
          logError('Error attempting to exit fullscreen', { error });
          reject(error);
        });
    } else {
      const error = new Error('Fullscreen API is not supported');
      logError(error);
      reject(error);
    }
  });
};

export const isFullscreenSupported = (): boolean => {
  return !!(
    document.exitFullscreen ||
    (document as any).webkitExitFullscreen ||
    (document as any).mozCancelFullScreen ||
    (document as any).msExitFullscreen
  );
};
